var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drill"},[_c('make-question-drill-math',{attrs:{"subjectCode":_vm.subjectCode,"problems":_vm.problems,"studyProblem":_vm.studyProblem,"drillType":_vm.isReport ? _vm.getDrillType.REPORT : undefined}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }